import * as React from "react";
import CONSTS from "../../../consts";
export default class Hero extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let supplier = this.props.supplier;
        let hero_image = `${CONSTS.STORAGEURL}/${CONSTS.LICENSEECONTAINER}/${supplier.Id}-Header.jpg`;
        let inpageNav = this.props.inpageNav;
        return (React.createElement("div", { className: "store-template-b__hero" },
            React.createElement("div", { className: "store-template-b__hero__image" },
                React.createElement("img", { src: hero_image })),
            React.createElement("div", { className: "store-template-b__hero__copy" },
                React.createElement("h2", null, supplier.HeroTitle),
                React.createElement("h4", null, supplier.HeroDescription),
                React.createElement("ol", { className: "store-template-b__hero__list" }, inpageNav.map((nav, index) => {
                    return React.createElement("li", { key: index },
                        React.createElement("a", { href: `#${nav}` }, nav));
                })))));
    }
}
;
//# sourceMappingURL=hero.js.map